import { Typography, styled } from '@mui/material'

export const StyledTypography = styled(Typography)<{
  component: React.ElementType
}>(({ theme }) => ({
  marginBottom: theme.spacing(3.5),
  [theme.breakpoints.up('md')]: {
    fontSize: 32,
    fontWeight: 500,
    lineHeight: '130%',
    textAlign: 'center',
  },
}))
